import dayjs from 'dayjs';
import dayjsMixin from '../../../../mixins/dayjs';
export default {
  name: 'CalendarMonth',
  mixins: [dayjsMixin],
  model: {
    prop: 'value',
    event: 'change',
  },
  events: ['change', 'selected'],
  props: {
    value: {
      type: [String, Object],
      default: null,
    },
  },
  data() {
    return {
      date: null,
      month: null,
      isSameDate: false,
    };
  },
  computed: {
    monthsOptions() {
      return dayjs.monthsShort().map((month, index) => ({
        label: month,
        value: index,
      }));
    },
  },
  watch: {
    value: {
      handler(value) {
        const date = dayjs(value);
        this.date = date.isValid() ? date : dayjs();
        this.month = this.date.month();
      },
      immediate: true,
    },
    month(value) {
      this.date = this.date.month(value);
    },
    date(value, oldValue) {
      this.isSameDate = value.isSame(oldValue, 'month');
      this.emitEvent('change', value);
    },
  },
  methods: {
    selected() {
      this.emitEvent('selected', this.date, false);
    },
    setMonth(value) {
      this.month = value;
      this.date = this.date.month(value);
      this.selected();
    },
    emitEvent(name, value, checkDate = true, props = this.value) {
      if (typeof props === 'string') {
        this.$emit(name, value.toISOString());
      } else {
        if (checkDate) {
          if (!this.isSameDate) this.$emit(name, value);
        } else {
          this.$emit(name, value);
        }
      }
    },
  },
};
